import type React from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { toast } from 'react-toastify'
import SignatureForm from '../components/SignatureForm'
import TagHeader from '../components/TagHeader'
import { useTagContext } from '../contexts/TagContext'

const DriverSign: React.FC = () => {
  const { tagId } = useParams()
  const navigate = useNavigate()
  const { isOffline, submitDriverSignature, getCurrentTag } = useTagContext()
  const currentTag = getCurrentTag(tagId)

  const handleSubmit = async (data: {
    name: string
    phone: string
    email: string
    signature: string
  }) => {
    if (!tagId) {
      toast.error('Tag ID is required')
      return
    }

    try {
      if (isOffline) {
        await submitDriverSignature(tagId, data.signature)
        navigate('/tags/completed/')
        toast.success('Changes will sync when back online', {
          style: { color: '#31C48D' },
        })
      } else {
        await submitDriverSignature(tagId, data.signature)
        navigate('/tags/completed/')
        toast.success('Driver signature submitted successfully', {
          style: { color: '#31C48D' },
        })
      }
    } catch (error) {
      console.error('Failed to process driver signature:', error)
      toast.error(
        error instanceof Error
          ? error.message
          : 'Failed to submit driver signature. Please try again.',
        { style: { color: '#721c24' } },
      )
    }
  }

  const isFormValid = (data: {
    name: string
    phone: string
    email: string
    signature: string
  }): boolean => {
    return !!data.signature
  }

  return (
    <div style={{ width: '100%' }}>
      <TagHeader
        title="Driver Signature"
        status={currentTag?.status || 'IN_PROGRESS'}
        tagId={tagId}
      />
      <div style={{ height: '20px' }} />
      {/*<SignatureForm
        confirmationText="I confirm loads have been delivered:"
        nameLabel="Driver Name"
        namePlaceholder="John Doe"
        phoneLabel="Driver Number"
        phonePlaceholder="+1 (702) 123-4567"
        emailLabel="Driver Email"
        emailPlaceholder="driver@example.com"
        submitButtonText="Accept & Send"
        onSubmit={handleSubmit}
        isValid={isFormValid}
        isPrefilled={true}
        defaultPhonePrefix="1"
      */}
    </div>
  )
}

export default DriverSign
